import { requestIdleCallback } from './requestIdleCallback'

/**
 * Wraps a function to be executed when the browser is idle.
 *
 * This is useful for tasks that are not critical to the user experience,
 * but should be executed as soon as possible.
 */
export function scheduleWhenIdle<Args extends unknown[]>(
  fn: (...args: Args) => void,
): (...args: Args) => void {
  return (...args: Args) => {
    requestIdleCallback(() => {
      fn(...args)
    })
  }
}
